import { render, staticRenderFns } from "./showStops-editor.vue?vue&type=template&id=b783ac98&scoped=true"
import script from "./showStops-editor.vue?vue&type=script&lang=js"
export * from "./showStops-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b783ac98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b783ac98')) {
      api.createRecord('b783ac98', component.options)
    } else {
      api.reload('b783ac98', component.options)
    }
    module.hot.accept("./showStops-editor.vue?vue&type=template&id=b783ac98&scoped=true", function () {
      api.rerender('b783ac98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/field-slider/showStops-editor.vue"
export default component.exports